__turbopack_context__.v({
  "description": "styles-module-scss-module__Ih5Ujq__description",
  "header": "styles-module-scss-module__Ih5Ujq__header",
  "imageContainer": "styles-module-scss-module__Ih5Ujq__imageContainer",
});
